"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardSection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CardSection = ({ children, glueBottom, version = 'normal' }) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: `p-3 ${glueBottom ? 'pb-0' : ''} ${version === 'comment' ? 'bg-light' : ''}`, children: children }));
};
exports.CardSection = CardSection;
